export default __webpack_public_path__ + "static/media/enbuild-logo.768d23b1.jpg";